import { useEffect } from 'react';
import { ExecutionList } from './ExecutionList';
import { ExecutionDetail } from './ExecutionDetail';
import { useConnectorDetailPageState } from '@/hooks/useConnectorDetailPageState';
import { useExecutionHistory } from '@/hooks/useConnectorExecutions';
import type { Connector } from '@/types/connectors';

interface Props { connector: Connector; }

export function ActivityTab({ connector }: Props) {
  const { executionId, setExecutionId } = useConnectorDetailPageState();
  const { data } = useExecutionHistory(connector.connectorType, connector.name, 1, 50);

  // Default selection = the first (most recent) execution from the history list.
  // The execution-history endpoint is the authoritative selection source —
  // connector.latest_execution carries only the single most-recent row.
  // Replace, not push: an automatic default must not add a history entry, or
  // browser Back from a connector lands on the same connector (#2161).
  const firstExecutionId = data?.executions?.[0]?.execution_id;
  useEffect(() => {
    if (!executionId && firstExecutionId) {
      setExecutionId(firstExecutionId, { replace: true });
    }
  }, [executionId, firstExecutionId, setExecutionId]);

  const selected = data?.executions?.find((e) => e.execution_id === executionId)
    ?? data?.executions?.[0]
    ?? null;

  return (
    <div className="grid grid-cols-1 gap-5 md:grid-cols-[320px_1fr]">
      <ExecutionList connectorType={connector.connectorType} name={connector.name} />
      {selected ? (
        <ExecutionDetail connectorType={connector.connectorType} execution={selected as any} />
      ) : (
        <div className="text-sm text-muted-foreground p-3">No executions yet — click Run Now to start one.</div>
      )}
    </div>
  );
}
